export default "__VITE_ASSET__BRr0Pn$2__"